import { computed, type Ref } from 'vue'
import type { Article } from '~/models/content'

export function useArticleRelated(articleRef: Ref<Article>) {
  const isDesktop = useDesktop()

  const enoughArticlesForSectionOne = computed(() => {
    const articles = articleRef.value?.relatedArticles || []
    return articles.length > 0
  })

  const enoughArticlesForSectionTwo = computed(() => {
    const articles = articleRef.value?.relatedArticles || []
    return articles.length > 6
  })

  const sectionOneArticles = computed(() => {
    const articles = articleRef.value?.relatedArticles || []
    if (articles.length <= 0) return []

    return isDesktop.value ? articles.slice(0, 4) : articles
  })

  const sectionTwoArticles = computed(() => {
    const articles = articleRef.value?.relatedArticles || []
    if (articles.length <= 5) return []

    return articles.slice(4)
  })

  return {
    enoughArticlesForSectionOne,
    enoughArticlesForSectionTwo,
    sectionOneArticles,
    sectionTwoArticles,
  }
}
